var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isEditorOrPublisher)?_c('InstructionViewPublisher',{ref:"instructionViewPublisher",attrs:{"task":_vm.task,"read-only":_vm.readOnly}}):_c('InstructionViewInspector',{ref:"instructionViewInspector",attrs:{"task":_vm.task,"read-only":_vm.readOnly}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }